import { useAuth } from "@/contexts/AuthContext";

export const AdminPage = ({ overline = "Administration", title, subtitle, actions, children, testid }) => {
  const { user } = useAuth();
  if (user?.role !== "admin") return <div className="p-10 text-slate-500" data-testid="admin-restricted">Administration is restricted to admins.</div>;
  return (
    <div className="px-4 sm:px-8 lg:px-12 py-8 space-y-6" data-testid={testid}>
      <div className="flex flex-col sm:flex-row sm:items-end justify-between gap-4">
        <div>
          <p className="overline">{overline}</p>
          <h1 className="text-3xl font-bold tracking-tight text-slate-900">{title}</h1>
          {subtitle && <p className="text-sm text-slate-500 mt-1 max-w-2xl">{subtitle}</p>}
        </div>
        {actions && <div className="flex flex-wrap gap-2">{actions}</div>}
      </div>
      {children}
    </div>
  );
};
